import { useEffect, useRef, useState } from 'react';
import { defaultFn } from 'destiny/dist/constants';
const useCountdown = (callback = defaultFn, initialValue = 3, intervalDuration = 1000) => {
  const [remainingTime, setRemainingTime] = useState<number>(initialValue);
  const interval = useRef<any>(null);

  useEffect(() => {
    startTimer();

    return () => interval?.current && clearInterval(interval.current);
  }, []);
  const startTimer = () => {
    if (remainingTime > 0) {
      interval.current = setInterval(() => {
        setRemainingTime((remainingTime) => {
          if (remainingTime === 1) {
            callback();
            clearInterval(interval.current);

            return 0;
          }

          return remainingTime >= 0 ? remainingTime - 1 : remainingTime;
        });
      }, intervalDuration);
    } else if (!interval.current && remainingTime !== 0) {
      clearInterval(interval.current);
      setRemainingTime(initialValue);
    }
  };

  return { remainingTime };
};

export default useCountdown;
